import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'durationFormat',
  standalone: true,
})
export class DurationFormatPipe implements PipeTransform {
  transform(value: string | undefined): string {
    if (!value) return '';

    // Parse TimeSpan string format (e.g., "00:05:29.5070000", "01:30:00", "00:45:30")
    // Format: HH:MM:SS.fffffff or HH:MM:SS
    const parts = value.split(':');

    if (parts.length < 2) return value; // Invalid format

    const hours = parseInt(parts[0] || '0');
    const minutes = parseInt(parts[1] || '0');
    const secondsPart = parts[2] ? parseFloat(parts[2]) : 0;

    const result: string[] = [];

    if (hours > 0) {
      result.push(`${hours}h`);
    }
    if (minutes > 0) {
      result.push(`${minutes}m`);
    }
    if (secondsPart > 0 && hours === 0) {
      // Only show seconds if less than an hour
      result.push(`${Math.floor(secondsPart)}s`);
    }

    return result.length > 0 ? result.join(' ') : '0m';
  }
}
